<template>
    <frm-input-smart-element-select
        v-model="selected"
        :label-all="$t('calendar.filter-devices-all')"
        :label-items="$tc('calendar.filter-devices', 2)"
        :multiple="multiple"
        :options="options"
        select-class="el-select--dark"
    />
</template>

<script>
    import FilterSelectItem from '../../../mixins/Calendar/FilterSelectItem';
    import sortArrayAlphabeticallyByProperty from '../../../services/sortArrayAlphabeticallyByProperty';

    export default {
        mixins: [FilterSelectItem],

        computed: {
            options() {
                const options = {};

                this.$store.getters['calendar/devices'].forEach(device => {
                    if (!(device.location.id in options)) {
                        options[device.location.id] = {
                            label: device.location.description,
                            options: [],
                        };
                    }

                    options[device.location.id].options.push({
                        id: device.id,
                        label: device.description,
                    });
                });

                return sortArrayAlphabeticallyByProperty(
                    Object.values(options).map(group => {
                        return { ...group, options: sortArrayAlphabeticallyByProperty(group.options, 'label') };
                    }),
                    'label'
                );
            },
        },
    };
</script>
